import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@store/auth';

/**
 * Sadece giriş yapmamış kullanıcılar için route'lar (login/register).
 * Zaten giriş yapmışsa dashboard'a yönlendirir.
 *
 * İstisna: ?davet=<token> query parametresi varsa (davet linki) authenticated
 * guard bypass edilir — RegisterPage mevcut session'ı temizleyip davet
 * akışına devam eder. Aksi halde davet edilen kullanıcı kendi login session'ı
 * yüzünden /dashboard'a düşüp daveti kabul edemez.
 */
export function PublicOnlyRoute() {
  const session = useAuthStore((s) => s.session);
  const loading = useAuthStore((s) => s.loading);
  const location = useLocation();

  if (loading) return null; // bootstrap bitsin

  const hasDavetToken = new URLSearchParams(location.search).has('davet');
  if (session && !hasDavetToken) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
